import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M15 3h3.5a1.5 1.5 0 0 1 0 3h-13a1.5 1.5 0 1 1 0-3H9l.414-.414A2 2 0 0 1 10.828 2h2.344a2 2 0 0 1 1.414.586zm4 5H5l.867 12.142A2 2 0 0 0 7.862 22h8.276a2 2 0 0 0 1.995-1.858z"
    }
  )
);
var SvgTrashFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var TrashFilled_default = SvgTrashFilled;

export { TrashFilled_default as default };
